import styled, { css } from 'styled-components'
import { BaseButton } from './BaseButton'
import { CommonButtonProps } from './types'

export const CommonButton = (props: CommonButtonProps) => {
  return <CommonButtonStyled {...props} />
}

const CommonButtonStyled = styled(({ variant, ...rest }: CommonButtonProps) => (
  <BaseButton {...rest} />
))`
  display: flex;
  flex-direction: row;
  height: 36px;
  border-radius: 36px;

  ${props => {
    switch (props.variant) {
      case 'success':
        return css`
          background-color: rgba(33, 44, 78, 1);
        `
      case 'danger':
        return css`
          background-color: rgba(255, 111, 97, 0.1);
        `
    }
  }}
`
